import { ChevronUp, ChevronDown } from 'lucide-react';

export interface SortIconProps {
  active: boolean;
  dir: 'asc' | 'desc';
}

export const SortIcon = ({ active, dir }: SortIconProps) => (
  <span className="inline-flex flex-col ml-1 -space-y-1.5 align-middle">
    <ChevronUp className={`w-3.5 h-3.5 ${active && dir === 'asc' ? 'opacity-100' : 'opacity-30'}`} />
    <ChevronDown className={`w-3.5 h-3.5 ${active && dir === 'desc' ? 'opacity-100' : 'opacity-30'}`} />
  </span>
);
